import { useMutation, useQueryClient } from "@tanstack/react-query";
import { LanguageSection } from "PFModules/saas_admin/accounts/edit/edit_account.types";

import { updateCustomization } from "../../../services/accounts/account";
import { accountsKeys } from "./query_keys";

type UseLocalesUpdate = {
  accountId: number;
  onSuccess: () => void;
  onError: (error: any) => void;
};

export const useLocalesUpdate = ({ accountId, onSuccess, onError }: UseLocalesUpdate) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (localesData: LanguageSection["languageSettings"]) =>
      updateCustomization(accountId, localesData),
    onSuccess: () => {
      queryClient.invalidateQueries(accountsKeys.locales(accountId));
      onSuccess();
    },
    onError: (error) => onError(error)
  });
};
